import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';
import { getSegmento } from "../util/generics.js";

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'x-segmento': getSegmento()
    }
})

class CatalogoRequest {

    /**
     * Llamada el endpoint de django para listar las regiones
     */
    static CargarRegiones() {
        return middleware.hasAuth(() => request.get(`regiones/`));
    }

    /**
     * Llamada el endpoint de django para listar las sucursales
     * dependiendo de la región seleccionada
     */
    static CargarSucursalesRegion(id_region) {
        return middleware.hasAuth(() => request.get(`sucursales/region/${id_region}/`));
    }

    /**
     * Llamada el endpoint de django para listar las plazas
     * dependiendo de la sucursal seleccionada
     */
     static CargarPlazas() {
        return middleware.hasAuth(() => request.get(`plazas/`));
    } 

    /**
    * Llamada el endpoint de django para listar las plazas
    * dependiendo de la sucursal seleccionada
    */
   static CargarSegmentos() {
       return middleware.hasAuth(() => request.get(`segmentos/`));
   }

    /**
     * Llamada el endpoint de django para obtener las plazas por sucursal
     * en la BD
     * @param: value
     * @return: Una lista de plazas.
     */
    static ListarPlazasSucursal(value,region_id = 0) {
        return middleware.hasAuth(() => request.get(`plazas/${value}/`,{
            params: {
                region_id:region_id
            }
        }));
    }

    /**
     * Llamada el endpoint de django para listar los sitios
     * dependiendo de la plaza filtrada por sucursal
     */
    static CargarSitiosPlaza(id_plaza,region_id = 0,sucursal_id = 0,segmento_id = 0) {
        return middleware.hasAuth(() => request.get(`sitios/`, {
            params: {
                plazas_id: id_plaza,
                region_id: region_id,
                sucursal_id: sucursal_id,
                segmento_id: segmento_id
            }
        }));
    }

    /**
     * Llamada el endpoint de django para listar las categorías
     */
    static CargarCategorias() {
        return middleware.hasAuth(() => request.get(`categorias/`));
    }

    /**
     * Llamada el endpoint de django para listar los sitios del usuario auth
     */
    static CargarSitiosByUsuario(id) {
        return middleware.hasAuth(() => request.get(`sitios_usuario`, {
            params: {
                id: id
            }
        }));
    }

    /**
         * Llamada el endpoint de django para obtener las cuentas contables
         * desde GP
         * @param: nada
         * @return: Una lista de cuentas contables GP.
         */
    static ListarCuentasGP(filtros) {
        return middleware.hasAuth(() => request.get(`cuenta_contable_gp`, {
            params: {
                cuenta: filtros?.cuenta,
                sitio_id: filtros?.sitio_id.toString(),
                es_costo: filtros?.es_costo
            }
        }))
    }

}

export default CatalogoRequest